// removed by extract-text-webpack-plugin
module.exports = {"m":"(min-width: 48em)","ixt-blue":"#003B5C","ixt-green-300":"#5ece84","ixt-yellow-300":"#ffe055","spacesize-s":"24px","spacesize-m":"48px","spacesize-l":"72px"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LinkCard.css
// module id = 566
// module chunks = 2